module.exports = __webpack_public_path__ + "static/media/image3_thumb.57a02756.jpeg";